export function objectToArray<T>(snapValue: Record<string, object>) {
  if (snapValue) {
    return Object.entries(snapValue).map((e) => ({ ...e[1], ...{ id: e[0] } })) as T[]
  }
  return []
}
